export function getPaginationDataFromResponse(responseObject) {
  const paginationDetails = {
    totalPages: responseObject.total_pages,
    totalCount: responseObject.count,
    nextPageUrl: responseObject.next,
    previousPageUrl: responseObject.previous,
    currentPage: responseObject.current_page,
    nextPage: responseObject.next_page,
    previousPage: responseObject.previous_page,
  }
  return paginationDetails
}
